export const globals = {
  instructionId: 0,
  isExecutingUndoRedo: false,
}